import { Link } from "@remix-run/react";
import { useTranslation } from "react-i18next";

import { ContentLayout } from "~/layout/content";

export const handle = {
  i18n: "notFound",
};

export default function WildCard() {
  const { t } = useTranslation();

  return (
    <ContentLayout>
      <div className="flex h-screen items-center justify-center bg-gray-100 dark:bg-gray-900">
        <div className="text-center">
          <h1 className="text-9xl font-bold text-gray-800 dark:text-gray-200">
            404
          </h1>
          <p className="mt-4 text-2xl font-medium text-gray-600 dark:text-gray-400">
            {t("notFoundTitle")}
          </p>
          <p className="mt-2 text-lg text-gray-500 dark:text-gray-500">
            {t("notFoundMessage")}
          </p>
          <Link
            to="/"
            className="mt-6 inline-block rounded bg-blue-600 px-6 py-2 text-white transition hover:bg-blue-700 dark:bg-blue-500 dark:hover:bg-blue-600"
          >
            {t("notFoundButton")}
          </Link>
        </div>
      </div>
    </ContentLayout>
  );
}
